// Tiny consent helper. Persists yes/no in localStorage; defaults to no
// until the user explicitly accepts in the cookie banner.

const KEY = "kakaiys.consent.v1";

export type ConsentValue = "granted" | "denied" | null;

export function getConsent(): ConsentValue {
  if (typeof window === "undefined") return null;
  try {
    const v = localStorage.getItem(KEY);
    if (v === "granted" || v === "denied") return v;
  } catch {}
  return null;
}

export function setConsent(v: "granted" | "denied") {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(KEY, v);
  } catch {}
  window.dispatchEvent(new CustomEvent("kakaiys:consent", { detail: v }));
}

export function hasConsent(): boolean {
  return getConsent() === "granted";
}
